module.exports = __webpack_public_path__ + "media/images/lb/562-c5efdcee9acf6d06d4326a6be030e178.svg";